import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomoUIService } from '../services/domo.ui.service';
import { BusinessRulesService } from 'app-modules/core/store/business-rules/business-rules.service';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { take } from 'rxjs/operators';
import { BusinessRuleInfo, BusinessRuleType, DashboardAccessResponse } from 'emr-ng-shared';
import { SIGMA_EMBED_PATH, SIGMA_IO_EMBED_PATH } from '../models/domo-config-consts';
import { CustomerDashboardService } from 'app-modules/core/store/customer-dashboard/customer-dashboard.service';
import { combineLatest, Subscription } from 'rxjs';
import { IListInfo } from 'app-modules/core/store/models/list-info-state.interface';
import { DashboardService } from 'app-modules/core/store/dashboard/dashboard.service';
import { SigmaDashboardComponent } from '../sigma-dashboard/sigma-dashboard.component';

@Component({
  selector: 'app-sigma-embed-dashboard',
  templateUrl: './sigma-embed-dashboard.component.html',
  styleUrls: ['./sigma-embed-dashboard.component.css'],
  standalone: true,
  imports: [SigmaDashboardComponent],
  providers: [DomoUIService]
})
export class SigmaEmbedDashboardComponent implements OnInit, OnDestroy {
  sigmaUrl: string = "";
  customerId: string;
  integrationID: string;
  combinedSubscription: Subscription;
  isPremium:boolean = false;
  
  constructor(
    private domoUIService: DomoUIService,
    private businessRulesService: BusinessRulesService,
    private router: Router,
    private custDBSvc: CustomerDashboardService,
    private dashboardSvc: DashboardService
  ) { }

  ngOnDestroy(): void {
    this.sigmaUrl = "";
    this.combinedSubscription?.unsubscribe();
  }
  ngOnInit(): void {
    this.customerId = JSON.parse(localStorage.getItem(environment.selectedCustomer));
    this.combinedSubscription = combineLatest([
      this.custDBSvc.customerDashboardList$,
      this.dashboardSvc.dashboardList$
    ]).subscribe(([customerDashboardData, dashboardData]) => {
      if (!dashboardData.isPaged) {
        // Process the customer dashboard list
        const customerDashboardInfo = customerDashboardData?.list?.find(x => x.CustomerID === Number(this.customerId));
        this.isPremium = customerDashboardInfo?.IsPremium || false;
        if (customerDashboardInfo?.IntegrationID) {
          this.integrationID = customerDashboardInfo.IntegrationID;
        } else {
          // Set integrationID from dashboard list
          this.integrationID = dashboardData?.list.filter(x => !x.IsPremium && x.DashboardName.toLowerCase().includes('sigma'))[0]?.IntegrationID;
        }
        if (this.integrationID) {
          // Perform business rule check
          this.CheckBusinessRule();
        } else {
          this.router.navigate(['']);
        }
      }
    });
  }

  CheckBusinessRule() {
    this.businessRulesService.businessRulesList$.pipe(take(1)).subscribe((businessRuleInfo: IListInfo<BusinessRuleInfo>) => {
      const hasDashboardLink = environment.showDashboardLink;
      const displayScorecardRule = businessRuleInfo.list?.find(
        br => br.BusinessRuleTypeCode === BusinessRuleType.DisplayScorecard
      )?.Enabled;

      if (hasDashboardLink && displayScorecardRule) {
        this.loadDashboard();
      } else {
        this.router.navigate(['']);
      }
    });
  }

  loadDashboard() {
    this.dashboardSvc.generateEmbedUrl(this.integrationID).pipe(take(1)).subscribe((response: DashboardAccessResponse) => {
      const token = encodeURIComponent(response.JwtToken);
      this.sigmaUrl =
      `${this.isPremium ? SIGMA_IO_EMBED_PATH : SIGMA_EMBED_PATH}` +
      `?:jwt=${token}` +
      `&:embed=true` +
      `&:menu_position=none` +
      `&CUSTOMERID=${this.customerId}`;
    });
  }
}
